<div class="hot-table hot-calibration-table">
  <hot-table [hotId]="hotTableId" [settings]="hotTableSettings" [licenseKey]="handsontableLicenseKey"></hot-table>
</div>

